module.exports = __webpack_public_path__ + "svg/file_pdf.a9dd7b419c195acc724b716301e49d92.svg";